<script setup>
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import { useTokenRefresh } from '@/composables/useTokenRefresh'

const store = useStore()
const { startTokenRefresh } = useTokenRefresh()

onMounted(() => {
  // Initialize auth state from localStorage
  store.dispatch('auth/initializeAuth')
  
  // Start token refresh if user is logged in
  if (store.getters['auth/isLoggedIn']) {
    startTokenRefresh()
  }
})
</script>

<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<style scoped>
html, body {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
}
</style>
